// Static column metadata for the board.
//
// All limits are null on purpose: the platform's real WIP config lives in
// wip-config.yml and is keyed by strategy / scope, not by board column. The
// previous per-column placeholders (`8`, `5`, `5`, `8`) had no relationship
// to backend enforcement — they painted an "0 / 5" badge on column headers
// that didn't represent anything the system actually cared about. The /wip
// endpoint surfaces the real scope-keyed counters in the settings modal,
// which is the correct place for that view.
//
// Columns now show count only (matching Done's pre-existing behavior). The
// drag-over WIP-block UI in App.tsx keys off `colDef.limit`, so with limit
// null it no-ops — drags can land anywhere. If a real per-column WIP policy
// ever becomes desirable, this file is the right place to put it.

import type { ColumnId } from './types';

export interface ColumnDef {
  id: ColumnId;
  title: string;
  limit: number | null;
  hint: string;
}

export const COLUMNS: readonly ColumnDef[] = [
  { id: 'backlog', title: 'Backlog', limit: null, hint: 'drafted · not yet enqueued' },
  { id: 'implementing', title: 'Implementing', limit: null, hint: 'agent writing code' },
  { id: 'review', title: 'In Review', limit: null, hint: 'review → fix → review' },
  { id: 'pr', title: 'Open PR', limit: null, hint: 'awaiting human merge' },
  { id: 'done', title: 'Done', limit: null, hint: 'merged · escalated' },
];

export function findColumn(id: ColumnId): ColumnDef | undefined {
  return COLUMNS.find((c) => c.id === id);
}
